import { SVGProps } from 'react';

export const Alert = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.3333 9.77778V5.33333C13.3333 2.38756 10.9467 0 8 0C5.05333 0 2.66667 2.38756 2.66667 5.33333V9.77778C2.66667 11.2507 1.472 12.4444 0 12.4444V13.3333H16V12.4444C14.528 12.4444 13.3333 11.2507 13.3333 9.77778Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.9375 14.2227C5.5535 15.2804 6.68772 16.0004 7.99972 16.0004C9.31261 16.0004 10.4459 15.2804 11.0628 14.2227H4.9375Z"
      fill="currentColor"
    />
  </svg>
);
